<div class="component-container w-full flex flex-col justify-center">
  <div class="heading text-center">
    Session {{sessionData?.sessionNumber}}
  </div>
  <div class="input-section flex flex-col gap-y-[2rem] justify-center items-center">
    <app-date-picker
      class="w-full"
      [parentFormGroup]="form"
      controlName="sessionDate"
      [error]="errorMessages['sessionDate']"
      (checkForErrors)="checkForErrors($event)"
      label="Session Date"
      placeholder="Select a date"
      type="small"
      [min]="minDate"
      [max]="maxDate"
    >
    </app-date-picker>
    <div class="row w-full flex flex-row gap-[1rem]">
      <app-time-picker
        class="w-1/2"
        [parentFormGroup]="form"
        controlName="startTime"
        [error]="errorMessages['startTime']"
        (checkForErrors)="checkForErrors($event)"
        label="Start Time"
        placeholder="Select time"
        type="small"
      ></app-time-picker>
      <app-number-input
        class="w-1/2"
        [parentFormGroup]="form"
        controlName="duration"
        [error]="errorMessages['duration']"
        (checkForErrors)="checkForErrors($event)"
        label="Duration"
        suffixText="Minutes"
        placeholder="00"
        type="small"
      >
      </app-number-input>
    </div>
  </div>
  <div class="action-panel flex flex-row justify-end items-center">
    <div
      class="icon-panel-submit w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleSubmit()"
    >
      <app-icon icon="check" cssClass="icon-panel-icon"></app-icon>
    </div>
    <div
      class="icon-panel-cancel w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleCancel()"
    >
      <app-icon icon="close" cssClass="icon-panel-icon"></app-icon>
    </div>
  </div>
</div>
